export const PROFILE_FIELDS = [
  { key: "description", label: "Description" },
  { key: "industry", label: "Industry" },
  { key: "tagline", label: "Tagline" },
  { key: "products_services", label: "Products / Services" },
  { key: "target_customer", label: "Target Customer" },
  { key: "brand_voice", label: "Brand Voice" },
  { key: "visual_identity", label: "Visual Identity" },
  { key: "social_presence", label: "Social Presence" },
  { key: "competitive_positioning", label: "Competitive Positioning" },
  { key: "actors", label: "Actors / Personalities" },
];

export const PROMOTION_TOOLTIP =
  "How promotional your content should be: 0 is purely audience-focused, 10 is like an ad.";

export const PROMOTION_COPY = {
  0: "Never mention the brand, focus on audience.",
  1: "Almost no brand mention, audience-first.",
  2: "Occasional brand mention, mostly audience.",
  3: "Light brand presence, rare brand nods.",
  4: "Some brand mention, mix leaning audience.",
  5: "Balanced, half mention brand, variety.",
  6: "More brand than not, still varied.",
  7: "Brand-forward, audience still considered.",
  8: "Mention brand, not overly aggressive.",
  9: "Strongly promotional, brand focus.",
  10: "Basically an ad.",
};
